/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  ConcernsIssueDto,
  CreateConcernsIssue,
  ListOfConcernsIssueDto,
  PagedResultOfConcernsIssueSummaryDto,
  SaveAllStatusConcernsIssue,
  SearchConcernsIssuesParams,
  UpdateConcernsIssue
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns a paged list of concernsissues matching the supplied filter and sort criteria.
 */
export const searchConcernsIssues = (
    params?: SearchConcernsIssuesParams,
 options?: SecondParameter<typeof customInstance<PagedResultOfConcernsIssueSummaryDto>>,) => {
      return customInstance<PagedResultOfConcernsIssueSummaryDto>(
      {url: `/deployment/concerns-and-issues`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Creates a new ConcernsIssue from the supplied command.
 */
export const createConcernsIssue = (
    createConcernsIssue: CreateConcernsIssue,
 options?: SecondParameter<typeof customInstance<ConcernsIssueDto>>,) => {
      return customInstance<ConcernsIssueDto>(
      {url: `/deployment/concerns-and-issues`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createConcernsIssue
    },
      options);
    }
  /**
 * @summary Returns the ConcernsIssue identified by the route id.
 */
export const getConcernsIssueById = (
    id: string,
 options?: SecondParameter<typeof customInstance<ConcernsIssueDto>>,) => {
      return customInstance<ConcernsIssueDto>(
      {url: `/deployment/concerns-and-issues/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Replaces the data of the ConcernsIssue identified by the route id.
 */
export const updateConcernsIssue = (
    id: string,
    updateConcernsIssue: UpdateConcernsIssue,
 options?: SecondParameter<typeof customInstance<ConcernsIssueDto>>,) => {
      return customInstance<ConcernsIssueDto>(
      {url: `/deployment/concerns-and-issues/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateConcernsIssue
    },
      options);
    }
  /**
 * @summary Removes the ConcernsIssue identified by the route id.
 */
export const deleteConcernsIssue = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/deployment/concerns-and-issues/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Replaces the data of the ConcernsIssue identified by the route id.
 */
export const saveAllStatusConcernsIssue = (
    saveAllStatusConcernsIssue: SaveAllStatusConcernsIssue,
 options?: SecondParameter<typeof customInstance<ListOfConcernsIssueDto>>,) => {
      return customInstance<ListOfConcernsIssueDto>(
      {url: `/deployment/concerns-and-issues/apply-status`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveAllStatusConcernsIssue
    },
      options);
    }
  export type SearchConcernsIssuesResult = NonNullable<Awaited<ReturnType<typeof searchConcernsIssues>>>
export type CreateConcernsIssueResult = NonNullable<Awaited<ReturnType<typeof createConcernsIssue>>>
export type GetConcernsIssueByIdResult = NonNullable<Awaited<ReturnType<typeof getConcernsIssueById>>>
export type UpdateConcernsIssueResult = NonNullable<Awaited<ReturnType<typeof updateConcernsIssue>>>
export type DeleteConcernsIssueResult = NonNullable<Awaited<ReturnType<typeof deleteConcernsIssue>>>
export type SaveAllStatusConcernsIssueResult = NonNullable<Awaited<ReturnType<typeof saveAllStatusConcernsIssue>>>
